
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./AdmitCardTablePage.css";

const TABLE_PAGE_LIMIT = 29;


function AdmitCardTablePage() {
  const { threeTable, fetchThreeTableSection } = useGlobalData();
  const [isUpdating, setIsUpdating] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [localAdmitCards, setLocalAdmitCards] = useState([]);
  // Removed unused initialLoadDone state
  const tableWrapperRef = useRef(null);

  // Initial + paginated load
  const loadAdmitCards = useCallback(async (nextOffset = 0, isInitial = false) => {
    setIsUpdating(true);
    try {
      await fetchThreeTableSection("admitCards", false, {
        preferLoadedData: false,
        fetchIfPartial: false,
        showLoading: false,
        skipLoader: !isInitial,
        limit: TABLE_PAGE_LIMIT,
        offset: nextOffset
      });
      setHasMore(true);
      setOffset(nextOffset);
      // Removed setInitialLoadDone as it's unused
    } finally {
      setIsUpdating(false);
    }
  }, [fetchThreeTableSection]);

  useEffect(() => {
    if (offset === 0) {
      setLocalAdmitCards(threeTable.admitCards || []);
      setHasMore((threeTable.admitCards || []).length === TABLE_PAGE_LIMIT);
      setOffset((threeTable.admitCards || []).length);
    }
  }, [threeTable.admitCards, offset]);


  // On mount: agar global state me data hai to wahi use karo, warna API call karo (aur skeleton dikhao)
  useEffect(() => {
    if ((threeTable.admitCards || []).length > 0) {
      setLocalAdmitCards(threeTable.admitCards);
      setHasMore(threeTable.admitCards.length === TABLE_PAGE_LIMIT);
      setOffset(threeTable.admitCards.length);
      // Removed setInitialLoadDone as it's unused
    } else {
      loadAdmitCards(0, true); // skipLoader: false for skeleton
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isUpdating) return;
      const el = tableWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 200) {
        loadAdmitCards(offset, false); // skipLoader: true for scroll
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, isUpdating, offset, loadAdmitCards]);

  // Show only approved admit cards
  const admitCards = localAdmitCards.filter(card => card.status === "approved");
  const jobs = threeTable.jobs || [];
  // ✅ Get job title by slug
  const getJobTitle = (jobSlug) => {
    const job = jobs.find(j => j.slug === jobSlug);
    return job ? job.title : jobSlug;
  };
  return (
    <div className="admit-table-container">
      <h2>Admit Card Table</h2>
      <div
        className="admit-table-wrapper"
        ref={tableWrapperRef}
        style={{ overflowY: "auto", maxHeight: "1400px" }}
      >
        <table className="admit-table">
          <thead>
            <tr>
              <th>Job Title</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {admitCards.map((item, i) => (
              <tr key={i}>
                <td className="job-title-cell">{getJobTitle(item.jobSlug)}</td>
                <td>
                  <Link to={`/mform/${item.jobSlug || item.slug}`} className="admit-link">Admit Card View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Status messages below the table */}
      {isUpdating && admitCards.length === 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading admit cards...
        </p>
      )}
      {isUpdating && admitCards.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading more admit cards...
        </p>
      )}
      {!isUpdating && !hasMore && admitCards.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#888" }}>
          No more admit cards.
        </p>
      )}
    </div>
  );
}

export default AdmitCardTablePage;
